import React from "react";
import { makeStyles } from "@material-ui/core/styles";

// Components
import Section from "../../components/Section/Section";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import Tac from "../../components/TermsAndConditions/TermsAndConditions";

import { language, getTextSingle } from "../../languages/Languages";
import securityContent, { supportContent } from "./securityContent";

const useStyles = makeStyles(theme => ({
  intro: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "relative"
  },
  contents: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-start",
    width: "100%",
    paddingTop: theme.spacing(6)
  },
  securityPolicy: {
    width: "100%",
    maxWidth: "768px"
  }
}));

const SecurityPage = () => {
  const classes = useStyles();
  const { title, reportTitle, supportTitle } = language.pages.security;

  return (
    <Section isMain>
      <div className={classes.intro}>
        <SectionTitle title={getTextSingle(title)} />
        <div className={classes.contents}>
          <div className={classes.securityPolicy}>
            <Tac
              id="security"
              title={getTextSingle(reportTitle)}
              text={securityContent}
            />
            <Tac
              id="support-and-maintenance"
              title={getTextSingle(supportTitle)}
              text={supportContent}
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default SecurityPage;
